import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  countryFieldWrapper: {
    marginTop: 0
  }
})

export default useStyles
